import {
  initializeLoadStateWithoutData,
  LoadState,
} from '@app/core/store/_prototypes/action-reducers/state/load.state';
import { Country, Gender, Language, Nationality } from '@app/core/types/common/common.types';
import { combineReducers, createSelector, props } from '@ngrx/store';
import { CoreState } from '@app/core/store/core.slice';
import { createLoadActions } from '@app/core/store/_prototypes/action-reducers/actions/load.actions';
import { createLoadReducer } from '@app/core/store/_prototypes/action-reducers/reducers/load.reducers';
import { loadSelector } from '@app/core/store/_prototypes/action-reducers/selectors/load.selectors';

const PREFIX = '[COMMON]';
export const stateKey = 'common';

export interface CommonState {
  countries: LoadState<Record<string, unknown>, Country[]>;
  genders: LoadState<Record<string, unknown>, Gender[]>;
  nationalities: LoadState<Record<string, unknown>, Nationality[]>;
  languages: LoadState<Record<string, unknown>, Language[]>;
  spokenLanguages: LoadState<Record<string, unknown>, Language[]>;
}

export const getCountries = createLoadActions<Record<string, unknown>, Country[]>(
  `${PREFIX} getCountries`,
  props<Record<string, unknown>>()
);
export const getGenders = createLoadActions<Record<string, unknown>, Gender[]>(
  `${PREFIX} getGenders`,
  props<Record<string, unknown>>()
);
export const getNationalities = createLoadActions<Record<string, unknown>, Nationality[]>(
  `${PREFIX} getNationalities`,
  props<Record<string, unknown>>()
);
export const getLanguages = createLoadActions<Record<string, unknown>, Language[]>(
  `${PREFIX} getLanguages`,
  props<Record<string, unknown>>()
);
export const getSpokenLanguages = createLoadActions<Record<string, unknown>, Language[]>(
  `${PREFIX} getSpokenLanguages`,
  props<Record<string, unknown>>()
);

export const commonReducers = combineReducers<CommonState>({
  countries: createLoadReducer(initializeLoadStateWithoutData<Record<string, unknown>, Country[]>(), getCountries),
  genders: createLoadReducer(initializeLoadStateWithoutData<Record<string, unknown>, Gender[]>(), getGenders),
  nationalities: createLoadReducer(
    initializeLoadStateWithoutData<Record<string, unknown>, Nationality[]>(),
    getNationalities
  ),
  languages: createLoadReducer(initializeLoadStateWithoutData<Record<string, unknown>, Language[]>(), getLanguages),
  spokenLanguages: createLoadReducer(
    initializeLoadStateWithoutData<Record<string, unknown>, Language[]>(),
    getSpokenLanguages
  ),
});

const stateSelector = createSelector(
  (state: CoreState) => state,
  (state: CoreState) => state[stateKey] as CommonState
);
const countriesStateSelector = createSelector(stateSelector, (state) => state.countries);
export const countriesState = loadSelector(countriesStateSelector);

const gendersStateSelector = createSelector(stateSelector, (state) => state.genders);
export const gendersState = loadSelector(gendersStateSelector);

const nationalitiesStateSelector = createSelector(stateSelector, (state) => state.nationalities);
export const nationalitiesState = loadSelector(nationalitiesStateSelector);

const languagesStateSelector = createSelector(stateSelector, (state) => state.languages);
export const languagesState = loadSelector(languagesStateSelector);

const spokenLanguagesStateSelector = createSelector(stateSelector, (state) => state.spokenLanguages);
export const spokenLanguagesState = loadSelector(spokenLanguagesStateSelector);
